import { render } from "./ValidationPrompt.vue?vue&type=template&id=345984ff&scoped=true"
import script from "./ValidationPrompt.vue?vue&type=script&lang=js"
export * from "./ValidationPrompt.vue?vue&type=script&lang=js"

import "./ValidationPrompt.vue?vue&type=style&index=0&id=345984ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345984ff"]])

export default __exports__